import React from 'react';
import { Tabs } from '@mui/material';
import { StyledTab } from './TabsMenu.styles';

const TabsMenu = ({ options, value, onChange, disableRipple = true }) => {
  const handleChange = (e, newValue) => {
    e.preventDefault();
    onChange(newValue);
  };

  return (
    <Tabs value={value} onChange={handleChange}>
      {options?.map((option, index) => (
        <StyledTab key={index} label={option} value={index} disableRipple={disableRipple} />
      ))}
    </Tabs>
  );
};

export default TabsMenu;
